/**
 * Favorites Module
 * Handles favorites counter updates and UI state
 */

export default function initFavorites() {
    jQuery(document).on('novigran:book-catalog:favorites:updated', function(event, data) {
        // Access the favorites count
        const favoritesCount = data.count;
        const hasFavorites = data.hasFavorites;
        
        if (hasFavorites) {
            jQuery('body').addClass('has-favorites');
        } else {
            jQuery('body').removeClass('has-favorites');
        }

        // Update the favorites counter
        const $favoritesButton = jQuery('.favorites-button');
        if ($favoritesButton.length) {
            let $counter = $favoritesButton.find('.favorites-counter');
            
            // Create counter if it doesn't exist
            if (!$counter.length) {
                $counter = jQuery('<div class="favorites-counter"></div>');
                $favoritesButton.find('> div').append($counter);
            }
            
            // Update counter text
            $counter.text(favoritesCount);
        }
    });
}

